/* Keep merchant-managed page copy, menu labels and product content consistent
   with the theme branding without changing stored Shopify image filenames. */
(function () {
  'use strict';
  var formerBrand = /\bphyltres\b/gi;
  var formerEmail = /[\w.+-]+@phyltres\.com/gi;
  var formerDomain = /\b(?:www\.)?phyltres\.com\b/gi;
  function copy(value) {
    return value.replace(formerEmail, 'bonjour@rosa-rosae.fr')
      .replace(formerDomain, 'rosa-rosae.fr').replace(formerBrand, 'Rosa Rosae');
  }
  function eligible(element) {
    return element && !element.closest('script,style,textarea,input,code,pre,template,[contenteditable="true"]');
  }
  function cleanText(node) {
    if (!eligible(node.parentElement)) return;
    var next = copy(node.nodeValue);
    if (next !== node.nodeValue) node.nodeValue = next;
  }
  function cleanElement(element) {
    if (!eligible(element)) return;
    ['alt', 'title', 'aria-label'].forEach(function (attribute) {
      var value = element.getAttribute(attribute);
      if (value !== null && copy(value) !== value) element.setAttribute(attribute, copy(value));
    });
    if (element.tagName !== 'A') return;
    var href = element.getAttribute('href');
    if (!href) return;
    if (/^mailto:[^?]*@phyltres\.com(?:\?|$)/i.test(href)) {
      element.setAttribute('href', 'mailto:bonjour@rosa-rosae.fr' + (href.indexOf('?') >= 0 ? href.slice(href.indexOf('?')) : ''));
      return;
    }
    try {
      var url = new URL(href, window.location.href);
      if (/^(?:www\.)?phyltres\.com$/i.test(url.hostname)) {
        element.setAttribute('href', url.pathname + url.search + url.hash);
      }
    } catch (_) { /* Leave non-URL anchors untouched. */ }
  }
  function clean(root) {
    if (root.nodeType === 3) return cleanText(root);
    if (root.nodeType !== 1) return;
    cleanElement(root);
    root.querySelectorAll('[alt],[title],[aria-label],a[href]').forEach(cleanElement);
    var walker = document.createTreeWalker(root, NodeFilter.SHOW_TEXT);
    var node;
    while ((node = walker.nextNode())) cleanText(node);
  }
  function start() {
    clean(document.body);
    new MutationObserver(function (records) {
      records.forEach(function (record) {
        if (record.type === 'characterData') cleanText(record.target);
        else if (record.type === 'attributes') cleanElement(record.target);
        else record.addedNodes.forEach(clean);
      });
    }).observe(document.body, { childList: true, subtree: true, characterData: true,
      attributes: true, attributeFilter: ['href','alt','title','aria-label'] });
  }
  if (document.readyState === 'loading') document.addEventListener('DOMContentLoaded', start);
  else start();
}());
